import { apiService, ApiResponse } from './api';

export interface CreateFunctionRequest {
  function_name: string;
  source_code: string;
  signature: string;
  description?: string;
  tags?: string[];
}

export interface CreateFunctionResponse {
  id: string;
  rufid: string;
  rufid_short: string;
  function_name: string;
  version?: string;
}

export interface ResolveRequest { rufid: string }
export interface ResolveResponse {
  accessible: boolean;
  function_id?: string;
  function_name?: string;
  version?: string;
  error?: string;
}

export interface UpdateFunctionRequest {
  rufid: string;
  function_name?: string;
  description?: string;
  tags?: string[];
  source_code?: string;
}

export interface ExecuteResponse {
  status: 'executed' | 'failed';
  result?: any;
  metrics?: any;
  error?: string;
}

const base = '/functions';

export const functionsService = {
  async create(body: CreateFunctionRequest): Promise<ApiResponse<CreateFunctionResponse>> {
    return apiService.post<CreateFunctionResponse>(`${base}/create`, body);
  },
  async resolve(rufid: string): Promise<ApiResponse<ResolveResponse>> {
    return apiService.post<ResolveResponse>(`${base}/resolve`, { rufid } as ResolveRequest);
  },
  async update(body: UpdateFunctionRequest): Promise<ApiResponse<any>> {
    return apiService.put<any>(`${base}/update`, body);
  },
  async execute(rufidShort: string, inputData?: any): Promise<ApiResponse<ExecuteResponse>> {
    const body = inputData ? inputData : undefined;
    return apiService.post<ExecuteResponse>(`${base}/${rufidShort}/execute`, body);
  },
  async remove(rufid: string): Promise<ApiResponse<void>> {
    return apiService.delete<void>(`${base}/${encodeURIComponent(rufid)}`);
  },
};

export default functionsService;
